import { ReactElement } from 'react';

import { Container } from './styles';

interface IProps {
  title: string;
  icon: ReactElement;
}

export const AdminTitle = ({ title, icon }: IProps) => (
  <Container>
    {icon}
    <h1>{title}</h1>
  </Container>
);
